module.exports = __webpack_public_path__ + "common/icon-arrow-next-e44d82b4b6ac0076621b31ddea519a31.svg";